import React, { useState, useEffect,useRef } from "react";
import Content from "../../../layout/content/Content";
import { Card, Spinner, FormGroup } from "reactstrap";
import {
    Button,
    Block,
    Row,
    Col,
    Icon,
} from "../../../components/Component";
import Swal from "sweetalert2";
import Head from "../../../layout/head/Head";
import OptionM from "../../components/DynmicOption/OptionM";
import OptionC from "../../components/DynmicOption/OptionC";
import { DownloadTableExcel } from 'react-export-table-to-excel';
import ES27RevisedUpdate from "./ES27RevisedUpdate";

const ES27RevisedView = ({ ...props }) => {
    const [dataactive, setdataactive] = useState([]);
    const [Totall, setTotal] = useState([]);
    const [Totall2, setTotal2] = useState([]);
    const [GTotal, setGTotal] = useState(0);
    const [userData, setuserData] = useState("");
    const month1 = ["Test", "JANUARY", "FEBRUARY", "MARCH", "APRIL", "MAY", "JUNE", "JULY", "AUGUST", "SEPTEMBER", "OCTOBER", "NOVEMBER", "DECEMBER"]
    const [employmentId, setemloymentId] = useState(sessionStorage.getItem("employmentId"));
    const [Draft, setDraft] = useState(true);
    const today = new Date();
    const tableRef = useRef(null);
    const [loading, setloading] = useState(false);
    const [formData, setFormData] = useState({
        EmploymentId: Number(props.employmentId),
        UserId: Number(localStorage.getItem("userId")),
        ParametersId: Number(props.parametersId),
        month: sessionStorage.getItem("CurrentMonth") === null ? (today.getMonth() === 0 ? 12 : today.getMonth()) : sessionStorage.getItem("CurrentMonth"),
        dummymonth: sessionStorage.getItem("CurrentMonth") === null ? month1[today.getMonth()] : month1[sessionStorage.getItem("CurrentMonth")],
        year: sessionStorage.getItem("CurrentYear") === null ? (today.getMonth() === 0 ? today.getFullYear() - 1 : today.getFullYear()) : sessionStorage.getItem("CurrentYear"),
        EmploymentRefId: sessionStorage.getItem("EmploymentRefId"),
    });
    const onInputChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
        //console.log(formData)
    };
    const Total = async (empId) => {

        const sendData = {

            EmploymentId: Number(empId),
        }
        //console.log(sendData)

        await fetch(process.env.REACT_APP_API_LINK + 'api/Data/GetES7Total1', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(sendData)

        })
            .then(response => response.json())
            .then(
                data => {

                    //console.log(data[0])
                    setTotal(data[0])
                })


    };
    const Total1 = async (empId) => {

        const sendData = {

            EmploymentId: Number(empId),
        }
        //console.log(sendData)

        await fetch(process.env.REACT_APP_API_LINK + 'api/Data/GetES7Total2', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(sendData)

        })
            .then(response => response.json())
            .then(
                data => {

                    //console.log(data[0])
                    setTotal2(data[0])
                })


    };
    const getdata2 = async () => {

        const sendData = {

            EmploymentRefId: Number(formData.EmploymentRefId),
        }


        await fetch(process.env.REACT_APP_API_LINK + 'api/Main/Getparameters', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(sendData)

        })
            .then(response => response.json())
            .then(
                data => {
                    //console.log(data)
                    setdataactive(data)
                })


    };
    const getdata = async () => {

        const sendData = {
            EmploymentId: Number(employmentId),
            UserId: Number(localStorage.getItem("userId")),
        }


        await fetch(process.env.REACT_APP_API_LINK + 'api/Main/Viewalldata', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(sendData)

        })
            .then(response => response.json())
            .then(
                data => {

                    if (data === "NO") {
                        setloading(false)
                        setDraft(true)

                    }
                    else {
                        setloading(false)
                        setDraft(false)
                        setemloymentId(data.employmentId)
                        getdata2()
                        Total(data.employmentId)
                        Total1(data.employmentId)
                        setuserData(data)
                    }

                })


    };
    const generate = async () => {
        if (formData.year > 0 && formData.month > 0) {
            setloading(false)
            const sendData = {
                UserId: Number(localStorage.getItem("userId")),
                EmploymentRefId: Number(formData.EmploymentRefId),
                YearId: Number(formData.year),
                MonthId: Number(formData.month),
            }
            //console.log(sendData)

            await fetch(process.env.REACT_APP_API_LINK + 'api/Main/GenerateEs27revised', {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(sendData)

            })
                .then(response => response.json())
                .then(
                    data => {
                        if (data === "Error") {
                            Swal.fire({
                                title: ' This Month Report is Already Submitted',
                                icon: 'error',

                            })
                        } else {
                            setloading(false)
                            getdata()
                        }

                    })
        } else {
            Swal.fire({
                icon: "warning",
                title: "Month or Year Not Selected",
                text: "Please Select Month and Year",
                focusConfirm: false,
            }).then(() => {
                props.history.push("/Dashboard")
            })
        }

    };
    useEffect(() => {
        if (employmentId > 0) {
            Total(employmentId)
            Total1(employmentId)

        }
    }, [GTotal])
    useEffect(() => {

        setloading(true)
        getdata()
    }, [])
    const onFormSubmit = async () => {

        Swal.fire({
            title: 'Are You Sure you want to Submit  ?',
            icon: 'question',
            showDenyButton: true,
            showCancelButton: false,
            confirmButtonText: 'Yes',
            confirmButtonColor: 'success',
            denyButtonText: `No`,
        }).then(async (result) => {

            if (result.isConfirmed) {
                const sendData = {

                    EmploymentId: employmentId,
                }

                //console.log(sendData)
                await fetch(process.env.REACT_APP_API_LINK + 'api/Main/Submitform', {
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(sendData)

                })
                    .then(response => response.json())
                    .then(
                        data => {
                            if (data === "Done") {
                                props.history.push("/Dashboard")
                            } else {
                                Swal.fire({
                                    title: 'Data Not Submitted',
                                    icon: 'error',

                                })
                            }

                        })


            } else if (result.isDenied) {
                getdata()
            }
        })



    };
    const onSaveDraftGoBack = async () => {

        Swal.fire({
            title: 'Data Saved Successfully',
            icon: 'success',

        })
        props.history.push("/Dashboard")
        getdata()

    };
    const onSaveDraft = async () => {

        Swal.fire({
            title: 'Data Saved Successfully',
            icon: 'success',

        })
        getdata2()
        getdata()


    };

    return (
        <React.Fragment>
            <Head title="AllUser" />
            <Content>
                {loading ? <Spinner color="success" /> :
                    <Block>
                        <Button onClick={() => window.location.href = '/Dashboard'} color="dark"><em class="icon ni ni-back-alt"></em> BACK</Button>
                        <Card className="card-bordered card-stretch" style={{ padding: 20 }}>
                            {/*<NavbarDynamic/>*/}
                            {localStorage.getItem("urole") === "7" ? <h3 style={{ marginBottom: 40 }}>Employment Return (ES8)    <DownloadTableExcel
                                filename={userData.user !== undefined ? "ES8 Report-" + userData.user.state : "ES8 Report"}
                                sheet="users"
                                currentTableRef={tableRef.current}
                            >
                                <Button style={{ float: "right" }} color="info" ><Icon class="icon ni ni-download"></Icon>Export Excel</Button>
                            </DownloadTableExcel>  </h3>: <h3 style={{ marginBottom: 40 }}>Employment Return (ES8)    <DownloadTableExcel
                                filename="ES8 Report"
                                sheet="users"
                                currentTableRef={tableRef.current}
                            >
                                <Button style={{ float: "right" }} color="info" ><Icon class="icon ni ni-download"></Icon>Export Excel</Button>
                            </DownloadTableExcel>  </h3>}

                            {Draft ? <Row className="gy-4">
                                <Col md="6">
                                    <OptionM catid="41" defaultValuemain={formData.dummymonth} onInputChange={onInputChange} namemain="month" mainid="month" />
                                </Col>
                                <Col md="6">
                                    <OptionC catid="42" defaultValuemain={formData.year} onInputChange={onInputChange} namemain="year" mainid="year" />
                                </Col>
                                <Col md="6">
                                    <Button color="success" onClick={() => generate()} >Generate</Button>
                                </Col>
                            </Row> :
                                <Card style={{ marginTop: 20, border: "2px solid black", padding: 10 }} className="card-bordered card-stretch">
                                    <Row className="gy-4">
                                        <Col md="6">
                                            <FormGroup>
                                                <label className="form-label" htmlFor="Month">
                                                    Center: <label style={{ fontWeight: "normal" }}>  {userData.user !== undefined ? userData.user.state : "Not Specified"}</label>
                                                </label>

                                            </FormGroup>
                                        </Col>
                                        <Col md="6">
                                            <FormGroup>
                                                <label className="form-label" htmlFor="Month">
                                                    Name of Employment Exchange: <label style={{ fontWeight: "normal" }}>  {userData.user !== undefined ? userData.user.answer1 : "Not Specified"}</label>
                                                </label>

                                            </FormGroup>
                                        </Col>
                                        <Col md="6">
                                            <FormGroup>
                                                <label className="form-label" htmlFor="Month">
                                                    Month: <label style={{ fontWeight: "normal" }}> {month1[userData.monthId]}</label>
                                                </label>

                                            </FormGroup>
                                        </Col>
                                        <Col md="6">
                                            <FormGroup>
                                                <label className="form-label" htmlFor="Month">
                                                    ES8: Return showing the work done by the Employment Exchanges by NCO: <label style={{ fontWeight: "normal" }}>  </label>
                                                </label>

                                            </FormGroup>
                                        </Col>
                                    </Row>
                                    <div className="card-inner-group" style={{ border: '2px solid black', padding: 2 }}>

                                        <div style={{ height: window.innerHeight - 300, width: 'auto', overflow: 'scroll' }} className="table-responsive">
                                            <table className="table" ref={tableRef} style={{ borderCollapse: "separate", borderSpacing: 0 }}>
                                                <thead style={{ position: '-webkit-sticky', position: "sticky", top: 0, backgroundColor: '#edecec' }}>
                                                    <div style={{ visibility: 'hidden', height: 0, width: 0 }}> <tr ><center> Center Name -{userData.user !== undefined ? userData.user.state : "Not Specified"}</center></tr></div>
                                                    <tr >

                                                        <th rowSpan="2" style={{ textAlign: 'center', border: '1px solid black', padding: 10, verticalAlign: 'inherit' }} >
                                                            S. No.

                                                        </th>
                                                        <th rowSpan="2" style={{ textAlign: 'center', border: '1px solid black', padding: 10, verticalAlign: 'inherit', minWidth: 100 }} >
                                                            Items
                                                        </th>
                                                        <th colSpan="3" style={{ textAlign: 'center', border: '1px solid black', padding: 10, verticalAlign: 'inherit' }} >
                                                            Total (All categories)

                                                        </th>
                                                        <th colSpan="3" style={{ textAlign: 'center', border: '1px solid black', padding: 10, verticalAlign: 'inherit' }} >
                                                            SC

                                                        </th>
                                                        <th colSpan="3" style={{ textAlign: 'center', border: '1px solid black', padding: 10, verticalAlign: 'inherit' }} >
                                                            ST

                                                        </th>
                                                        <th colSpan="3" style={{ textAlign: 'center', border: '1px solid black', padding: 10, verticalAlign: 'inherit' }} >
                                                            OBC

                                                        </th>
                                                        <th colSpan="3" style={{ textAlign: 'center', border: '1px solid black', padding: 10, verticalAlign: 'inherit' }} >
                                                            PWD

                                                        </th>
                                                        <th colSpan="3" style={{ textAlign: 'center', border: '1px solid black', padding: 10, verticalAlign: 'inherit' }} >
                                                            Minority Community

                                                        </th>



                                                    </tr>
                                                    <tr>

                                                        <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold", minWidth: 150 }} > Male</td>
                                                        <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold", minWidth: 150 }} > Female</td>
                                                        <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold", minWidth: 150 }} > Transgender</td>
                                                        <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold", minWidth: 150 }} > Male</td>
                                                        <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold", minWidth: 150 }} > Female</td>
                                                        <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold", minWidth: 150 }} > Transgender</td>
                                                        <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold", minWidth: 150 }} > Male</td>
                                                        <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold", minWidth: 150 }} > Female</td>
                                                        <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold", minWidth: 150 }} > Transgender</td>
                                                        <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold", minWidth: 150 }} > Male</td>
                                                        <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold", minWidth: 150 }} > Female</td>
                                                        <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold", minWidth: 150 }} > Transgender</td>
                                                        <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold", minWidth: 150 }} > Male</td>
                                                        <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold", minWidth: 150 }} > Female</td>
                                                        <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold", minWidth: 150 }} > Transgender</td>
                                                        <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold", minWidth: 150 }} > Male</td>
                                                        <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold", minWidth: 150 }} > Female</td>
                                                        <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold", minWidth: 150 }} > Transgender</td>

                                                    </tr>


                                                </thead>

                                                <tbody>

                                                    {dataactive !== [] ? dataactive.map((details) =>

                                                        details.parentId <= 0 ?
                                                            <tr scope="row" >

                                                                <td >
                                                                    {details.parentId === -1 ? null :
                                                                        <b>  {details.sno}</b>
                                                                    }
                                                                </td>
                                                                <td>
                                                                    <b>  {details.name}</b>



                                                                </td>
                                                                {details.parentId === -1 ?
                                                                    <>


                                                                        <td style={{ textAlign: 'center', padding: 10 }}>
                                                                            {Totall.totalAllCategoriesM3}
                                                                        </td>
                                                                        <td style={{ textAlign: 'center', padding: 10 }}>
                                                                            {Totall.totalAllCategoriesF4}
                                                                        </td>
                                                                        <td style={{ textAlign: 'center', padding: 10 }}>
                                                                            {Totall.totalAllCategoriesT5}
                                                                        </td>
                                                                        <td style={{ textAlign: 'center', padding: 10 }}>
                                                                            {Totall.scm6}
                                                                        </td>
                                                                        <td style={{ textAlign: 'center', padding: 10 }}>
                                                                            {Totall.scf7}
                                                                        </td>
                                                                        <td style={{ textAlign: 'center', padding: 10 }}>
                                                                            {Totall.sct8}
                                                                        </td>
                                                                        <td style={{ textAlign: 'center', padding: 10 }}>
                                                                            {Totall.stm9}
                                                                        </td>
                                                                        <td style={{ textAlign: 'center', padding: 10 }}>
                                                                            {Totall.stf10}
                                                                        </td>
                                                                        <td style={{ textAlign: 'center', padding: 10 }}>
                                                                            {Totall.stt11}
                                                                        </td>
                                                                        <td style={{ textAlign: 'center', padding: 10 }}>
                                                                            {Totall.obcm12}
                                                                        </td>
                                                                        <td style={{ textAlign: 'center', padding: 10 }}>
                                                                            {Totall.obcf13}
                                                                        </td>
                                                                        <td style={{ textAlign: 'center', padding: 10 }}>
                                                                            {Totall.obct14}
                                                                        </td>
                                                                        <td style={{ textAlign: 'center', padding: 10 }}>
                                                                            {Totall.phm15}
                                                                        </td>
                                                                        <td style={{ textAlign: 'center', padding: 10 }}>
                                                                            {Totall.phf16}
                                                                        </td>
                                                                        <td style={{ textAlign: 'center', padding: 10 }}>
                                                                            {Totall.pht17}
                                                                        </td>
                                                                        <td style={{ textAlign: 'center', padding: 10 }}>
                                                                            {Totall.minorityCommunityM18}
                                                                        </td>
                                                                        <td style={{ textAlign: 'center', padding: 10 }}>
                                                                            {Totall.minorityCommunityF19}
                                                                        </td>
                                                                        <td style={{ textAlign: 'center', padding: 10 }}>
                                                                            {Totall.minorityCommunityT20}
                                                                        </td>
                                                                    </>

                                                                    : null}

                                                            </tr> :
                                                            <ES27RevisedUpdate sno={details.sno} setGTotal={setGTotal} GTotal={GTotal} edit={false} name={details.name} parametersId={details.parametersId} employmentId={employmentId} ES27RevisedUpdate={ES27RevisedUpdate} />

                                                    ) : null}
                                                    <tr scope="row" >

                                                        <td>



                                                        </td>

                                                        <td>

                                                            <b>  Total</b>

                                                        </td>
                                                        <td style={{ textAlign: 'center', padding: 10 }}>
                                                            {Totall2.totalAllCategoriesM3}
                                                        </td>
                                                        <td style={{ textAlign: 'center', padding: 10 }}>
                                                            {Totall2.totalAllCategoriesF4}
                                                        </td>
                                                        <td style={{ textAlign: 'center', padding: 10 }}>
                                                            {Totall2.totalAllCategoriesT5}
                                                        </td>
                                                        <td style={{ textAlign: 'center', padding: 10 }}>
                                                            {Totall2.scm6}
                                                        </td>
                                                        <td style={{ textAlign: 'center', padding: 10 }}>
                                                            {Totall2.scf7}
                                                        </td>
                                                        <td style={{ textAlign: 'center', padding: 10 }}>
                                                            {Totall2.sct8}
                                                        </td>
                                                        <td style={{ textAlign: 'center', padding: 10 }}>
                                                            {Totall2.stm9}
                                                        </td>
                                                        <td style={{ textAlign: 'center', padding: 10 }}>
                                                            {Totall2.stf10}
                                                        </td>
                                                        <td style={{ textAlign: 'center', padding: 10 }}>
                                                            {Totall2.stt11}
                                                        </td>
                                                        <td style={{ textAlign: 'center', padding: 10 }}>
                                                            {Totall2.obcm12}
                                                        </td>
                                                        <td style={{ textAlign: 'center', padding: 10 }}>
                                                            {Totall2.obcf13}
                                                        </td>
                                                        <td style={{ textAlign: 'center', padding: 10 }}>
                                                            {Totall2.obct14}
                                                        </td>
                                                        <td style={{ textAlign: 'center', padding: 10 }}>
                                                            {Totall2.phm15}
                                                        </td>
                                                        <td style={{ textAlign: 'center', padding: 10 }}>
                                                            {Totall2.phf16}
                                                        </td>
                                                        <td style={{ textAlign: 'center', padding: 10 }}>
                                                            {Totall2.pht17}
                                                        </td>
                                                        <td style={{ textAlign: 'center', padding: 10 }}>
                                                            {Totall2.minorityCommunityM18}
                                                        </td>
                                                        <td style={{ textAlign: 'center', padding: 10 }}>
                                                            {Totall2.minorityCommunityF19}
                                                        </td>
                                                        <td style={{ textAlign: 'center', padding: 10 }}>
                                                            {Totall2.minorityCommunityT20}
                                                        </td>


                                                    </tr>

                                                </tbody>
                                            </table>

                                        </div>



                                    </div>
                                   
                                </Card>}



                        </Card>

                    </Block>}

            </Content>

        </React.Fragment>
    );
};

export default ES27RevisedView;
